import { render } from "./AntragstellerWizardVertretungsberechtigte.pug?vue&type=template&id=23dac8a8&lang=pug"
import script from "./AntragstellerWizardVertretungsberechtigte.js?vue&type=script&lang=js"
export * from "./AntragstellerWizardVertretungsberechtigte.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__